// src/components/LoadingPopUp.jsx
import React from 'react';
import { Modal, Backdrop, Box, CircularProgress, Typography } from '@mui/material';

const LoadingPopUp = ({ open }) => (
    <Modal
        open={open}
        // Modal'ın kendi backdrop'unu kullanıyoruz ve tamamen şeffaf yapıyoruz
        BackdropComponent={Backdrop}
        BackdropProps={{
            sx: {
                backgroundColor: 'transparent',
            },
        }}
        sx={{
            pointerEvents: 'none',
            outline: 'none',
        }}
        closeAfterTransition
    >
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 0,
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                pointerEvents: 'auto',
                border: 'none',
            }}
        >
            <CircularProgress sx={{ mb: 1 }} />
            <Typography variant="body2">Yükleniyor...</Typography>
        </Box>
    </Modal>
);

export default LoadingPopUp;
